var map = {
	"./amazonpay.jpg": "f1eb",
	"./applepay.jpg": "6bca",
	"./bancontact.jpg": "756c",
	"./banktransfer-de.jpg": "7ae5",
	"./banktransfer-en.jpg": "8c0a",
	"./banktransfer-es.jpg": "c709",
	"./banktransfer-fr.jpg": "3edf",
	"./banktransfer-it.jpg": "f680",
	"./cashondelivery-de.jpg": "01cb",
	"./cashondelivery-en.jpg": "0b55",
	"./cashondelivery-es.jpg": "5df6",
	"./cashondelivery-fr.jpg": "2414",
	"./cashondelivery-it.jpg": "4ad0",
	"./companycredit.jpg": "fc59",
	"./googlepay.jpg": "d67c",
	"./hipay.jpg": "15b8",
	"./klarna.jpg": "deef",
	"./mastercard.jpg": "7054",
	"./oney.jpg": "4727",
	"./paypal.jpg": "a02e",
	"./scalapay.jpg": "b4fc",
	"./sofort.jpg": "c117",
	"./stripe_card.jpg": "25eb2",
	"./visa.jpg": "fef9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fd7";